import { SkeletonTheme } from 'react-loading-skeleton'
import { designSystemTheme } from '@velasca/constants'

const theme = designSystemTheme.man

export const withSkeletonTheme = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <SkeletonTheme {...theme.colors.skeleton}>
        <WrappedComponent {...props} />
      </SkeletonTheme>
    )
  }
}
